import {gql} from 'apollo-angular';

export function createDepartment(fields: string[]) {
  return gql`
    mutation createDepartment($department: DepartmentDto!) {
      createDepartment(department: $department) {
        ${fields.join('\n')}
      }
    }`;
}

export function retrieveDepartmentsByCompanyId(fields: string[]) {
  return gql`
    query retrieveDepartmentsByCompanyId($companyId: String!) {
      retrieveDepartmentsByCompanyId(companyId: $companyId) {
        ${fields.join('\n')}
      }
    }`;
}

export function retrieveEligibleParentDepartments(fields: string[]) {
  return gql`
    query retrieveEligibleParentDepartments($currentDepartmentId: String, $companyId: String!) {
      retrieveEligibleParentDepartments(currentDepartmentId: $currentDepartmentId, companyId: $companyId) {
        ${fields.join('\n')}
      }
    }`;
}

export function removeDepartment() {
  return gql`
    mutation removeDepartment($id: String!) {
      removeDepartment(id: $id)
    }`;
}

export function retrieveDepartmentById(fields: string[]) {
  return gql`
    query retrieveDepartmentById($id: String!, $companyId: String!) {
      retrieveDepartmentById(id: $id, companyId: $companyId) {
        ${fields.join('\n')}
      }
    }`;
}

export function updateDepartment(fields: string[]) {
  return gql`
    mutation updateDepartment($department: DepartmentDto!) {
      updateDepartment(department: $department) {
        ${fields.join('\n')}
      }
    }`;
}
